import { FC, useState } from 'react';
import { useDispatch } from 'react-redux';
import dayjs, { Dayjs } from 'dayjs';
import { useSearchParams } from 'react-router-dom';
import { unwrapResult } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { LockOpenOutlined as Lock } from '@mui/icons-material';
import { Tooltip } from '@mui/material';

import { dateNormalizer, errorNormalizer } from '../../../shared/Helpers/functions';
import { CustomAlert, CustomButton, Picker } from '../../../shared/uiComponents';
import { Wrapper } from '../Admin/helpers';

import { DispatchProperties, useSelector } from '../../../redux/store';
import { getSoapNotesAdmin, unlockSoapNote } from '../../../redux/State/clientSlice/soapNoteSlice';

const initialExpirationDate = dayjs().add(2, 'days');

const Unlock: FC<{ clientId: string; reportId: string }> = ({ reportId, clientId }) => {
	const dispatch = useDispatch<DispatchProperties>();
	const [params] = useSearchParams();
	const isUpdating = useSelector((state) => state.soapNote.isUpdating);
	const filterData = useSelector((state) => state.billing.billingFilters);

	const [addNextExpiration, setAddNextExpiration] = useState<boolean>(false);
	const [expirationDateValue, setExpirationDateValue] = useState<Dayjs | null>(initialExpirationDate);

	const unlockHandler = () => {
		if (!reportId) return;
		const page = params.get('page') || '1';
		const pageSize = params.get('pageSize') || '8';
		const direction = params.get('direction') || '';
		const orderBy = params.get('orderBy') || '';
		const searchString = params.get('search') || '';
		const status = params.get('status') || '';
		const { endDate, startDate, userId } = filterData;

		dispatch(
			unlockSoapNote({
				reportId,
				clientId,
				nextExpirationDate: dateNormalizer(dayjs(expirationDateValue)),
			}),
		)
			.then(unwrapResult)
			.then(() => {
				dispatch(
					getSoapNotesAdmin({
						page,
						pageSize,
						direction,
						orderBy,
						searchString,
						status,
						endDate,
						startDate,
						userId,
						clientId,
					}),
				);
				toast('Success');
			})
			.catch(errorNormalizer);
	};

	return (
		<Wrapper unlockConfirm={false}>
			<Tooltip title="Unlock">
				<Lock sx={{ fontSize: '16px' }} onClick={() => setAddNextExpiration(true)} />
			</Tooltip>
			<CustomAlert
				isBusy={isUpdating}
				title="Set next expiration date"
				onClose={() => setAddNextExpiration(false)}
				open={addNextExpiration}
				Content={() => (
					<>
						<Picker.CustomDate
							label="Expiration date"
							value={expirationDateValue}
							onChange={setExpirationDateValue}
							className="marginBottom16"
						/>
						<CustomButton title="Unlock" onClick={unlockHandler} className="marginBottom16" />
						<CustomButton buttonType="secondaryGray" title="Cancel" onClick={() => setAddNextExpiration(false)} />
					</>
				)}
			/>
		</Wrapper>
	);
};

export default Unlock;
